import React from 'react'

const Dba = () => {
    return (
        <div>
            <h1  style={{textAlign: 'center'}}>Database Administrator Roadmap</h1>
            <div class="main clearfix">
<div class="content clearfix"><div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row        ">
<div class="medium-12 columns "><div class="text parbase section">
<div class="text-component    text-left">
<p><span style={{fontFamily: 'inherit' ,lineHeight: '1.4', letterSpacing: '-0.015em'}}>Every day, we create an estimated 2.5 quintillion (that’s a 1 with 18 zeros, just FYI) bytes of data, and this amount is accelerating at an exponential rate. More data has been collected in the past two years than in the entire human history.&nbsp;So where does all this data go? One of the foundational locations is a database. Without the database and ability to query the database, it would be nearly impossible to analyze any of that data in a meaningful way. It’s a truly exciting time in the data world with new approaches to data collection, manipulation and types of databases. With this, we need gatekeepers and maintainers for all these treasure chests of information. A group most commonly called database administrators. &nbsp; &nbsp;</span><br/>

</p>
<p>&nbsp;</p>
</div>
</div>
<div class="title section">
<div data-emptytext="Title">
<h3 class="     title--center    ">
What is a database administrator?
</h3>
</div></div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row        ">
<div class="medium-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="text parbase section">
<div class="text-component    text-left">
<p>&nbsp;</p>
<p>Database Administration consists of everything required to manage a database and make it available as needed. The database administrator (DBA) is the person who manages, backs up and ensures the availability of the data produced and consumed by today’s organizations via their IT systems. The DBA is a critically important role in many of today’s IT departments, and by extension, their organizations overall.</p>
<p><span style={{fontFamily: 'inherit', lineHeight: '1.4' ,letterSpacing: '-0.015em'}}>For example, consider a commercial bank: the DBA is the person who ensures that the bank teller has easy, fast access to your information, and can quickly access your bank balance and transaction history. In this example, the DBA is a system or application-database administrator—a general DBA role responsible for most aspects of the organization’s databases. However, this is not the only kind of DBA.</span></p>
</div>
</div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row        ">
<div class="medium-12 columns "><div class="text parbase section">
<div class="text-component    ">
<p>A database administrator's responsibilities may include:<br/>

</p>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<div class="list section"><div class="list-comp">
<ul>
<li> Installing and upgrading the database server and/or application tools.</li>
<li> Planning for and allocating the database system’s physical requirements, such as memory, disk space, network requirements, etc.</li>
<li> Modifying the database structure using information provided by application developers.</li>
<li> Creating users profiles, and ensuring system security by careful allocation of user permissions.</li>
<li> Ensuring compliance with database vendor license agreement, including number of installations, and taking care of licensing renewals.</li>
<li> Creating a backup and recovery strategy for the database, and regularly testing the backups to ensure usability.</li>
<li> Monitoring technical support for both database systems and related applications.</li>
<li> Creating reports by querying from database (as per need). These reports can be in the form of pre-formatted reports using the application frontend, or custom-made ad hoc reports by the database administrator. </li>
<li> Monitoring and optimizing the database’s performance using either manual or automated tools. This may be a DBA’s most important tasks.</li>
<li> Migrating database instances to new hardware and new versions of software from on premise to cloud based databases and vice versa.</li>
</ul>
</div>
</div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="title section">
<div data-emptytext="Title">
<h3 class="     title--center    ">
Database administrator specializations
</h3>
</div></div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="text parbase section">
<div class="text-component    ">
<p>Just as the term ‘doctor’ can refer to a wide range of specializations, there is also a wide range of <a href="http://www.craigsmullins.com/dbta_065.htm">sub-specializations for the database administrator role</a>. The DBA we described previously is the most common—one who works in-house or on contract for an organization to keep their internal databases chugging along optimally.</p>
<p>There are also database administrators who create and design databases in the first place. They usually work as part of a team, often in a more specialized software development company. And that database is likely to be part of a larger application for some specific business need. In the commercial bank example we used earlier, the bank most likely purchases or leases the software to run its banking operations from an Information Communication and Technology (ICT) company that specializes in banking software. This banking software is underpinned by a database, which is the backend storage for all the data, and that was designed and built by a team of specialist DBAs (more properly called <b>‘</b>database designers’). They likely work with business analysts and others who are intimately familiar with banking operations to design the various application’s functions and modules. This is to ensure that all bank functions (loans, cash transactions, automated payments, ATM management, etc.) are created and reflected in the database structure.</p>
<p>Yet, another type of database administrator is the Performance Database Administrator or Tuning Database Administrator.<b> </b>This administrator specializes in optimizing and improving the performance of various databases. Databases are complex pieces of software. Simply put, a database’s internal structure consists of data stored within tables. Data access can then be optimized by use of indexes, which read like a book’s table of contents. DBAs help to ensure that the database is optimized to take advantage of the physical or virtual hardware on which it is hosted. This means it’s necessary to be able to split data across different disks, set up the database to better use the memory or RAM and optimize the network traffic of remote databases. Some databases are even split among multiple servers in so-called ‘distributed setups.’ Some databases can get so complex that they need a DBA who focuses solely on performance improvement. However, for smaller, single-company databases a non-specialist DBA is usually sufficient.</p>
<p>A third type of database administrator is the Application DBA. This role focuses specifically on integrating databases into the applications that use them. Navigating most databases usually requires knowledge of a specific type of query language. The most common is the Structured Query Language, or <a href="https://www.pluralsight.com/blog/data-professional/learning-path-querying-sql-server-70-461">SQL</a>. Most users will not learn how to use and navigate SQL; instead they will use a front end application to carry out the tasks required of them. In a commercial bank, this application is the banking software itself (the users are only able to access the database via an application, which ensures data security). It is the work of the application DBA to ensure that the database and the application using it communicate properly, and that accurate results are communicated between the two. For instance, when a user enters a customer name and clicks to display their bank account balance, the database returns the correct amount and not, say, the loan balance.</p>
</div>
</div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="title section">
<div data-emptytext="Title">
<h3 class="     title--center    ">
Employment outlook for database administrators
</h3>
</div></div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="text parbase section">
<div class="text-component    ">
<p>Being a database administrator or database manager is a rewarding, challenging career path. It also means handling significant responsibility as the custodian of an organization’s data, in addition to being responsible for turning the raw data into actionable intelligence. Let’s turn back to the commercial bank example: Bank staff enter thousands, perhaps millions of pieces of data about their customers every day, including bank balances, loan applications, loan repayments, new account openings, account closures, new checkbook requests, etc. These pieces of discrete data held within the database are not really useful as is. What is very useful is extracting information from them, by analyzing trends and patterns. For example, you may run a report and notice that a certain type of client is the one at the highest risk of defaulting on their loans, or that 65% of clients order new checkbooks in November and December. This is the real value proposition of databases, and by extension, database administrators—the ability to transform raw data into real business intelligence.</p>
<p>The ubiquitous nature of computing, coupled with the self-evident advantages of databases, means that demand for good DBAs in today’s workplace is quite high. Pay for DBAs is of course tied directly to level of seniority, years of experience and the specific database system specialization. The ‘traditional’ database platforms are the so-called relational databases, such as the Oracle DB, Microsoft SQL Server and IBM’s DB2. There is a newer breed of database called non-relational databases designed mainly to handle very large volumes of data (called <a href="https://www.pluralsight.com/search?q=big+data&amp;categories=all">Big Data</a>), typically from large websites such as Google, Amazon, Ebay and Facebook. You can check out more on the rise of non-relational databases <a href="https://www.techopedia.com/6/28832/enterprise/databases/introduction-to-databases/6">here</a>.</p>
<p>According to<a href="http://www.payscale.com/research/US/Job=Database_Administrator_%28DBA%29/Salary"> remuneration-tracker Payscale</a>, the median base database administrator salary across the U.S. was $67,733 in 2015, or a base hourly rate of $22. However, this is simply a rough average, ranging from a starting salary in the low 40ks for an entry-level DBA position, to the high $200ks for an expert, senior database administrator in charge of multi-terabyte distributed databases for large corporations. These senior-level positions are far less likely to be concerned with the technical day-to-day aspects of database management. Instead, they are strategic-level senior management positions within the ICT department, and often head large, multi-site teams of DBAs. Nevertheless, most senior database managers begin their careers as techie DBAs, tinkering with and learning the various aspects of databases and database management.</p>
<p>Another remuneration tracker website, <a href="http://www.itcareerfinder.com/">ITcareerfinder</a>, lists a median DBA salary of <a href="http://www.itcareerfinder.com/brain-food/it-salaries/database-administrator-salary-range.html">$58,000</a>. However, <i>SQLMag</i> conducted a 2015 survey to track database professionals’ salaries, and concluded that they range from <a href="http://sqlmag.com/sql-server/look-sql-server-and-data-related-salaries-2015">~$70,000– $160,000</a>, showing increases of 5–9% over the previous year, depending on specific job description. Demand for database administrators is projected to grow at 15% annually for the next 10 years, so DBA job-growth is also more or less assured. In fact, the magazine <i>US News</i> ranked database administrator sixth in its top 10<a href="https://money.usnews.com/careers/best-jobs/rankings/best-technology-jobs"> list of Best Technology Jobs</a>.</p>
<p><span style={{fontFamily: 'inherit', lineHeight: '1.4' ,letterSpacing: '-0.015em'}}>Of course, experience level and specific training in specific database software could mean significant deviation from this mean. Other factors affecting DBA remuneration are:</span><br/>

</p>
</div>
</div>
<div class="list section"><div class="list-comp">
<ul>
<li>Location: DBA jobs in large cities and technology hubs such as San Francisco generally pay 10–40% better than similar database administrator jobs elsewhere.</li>
<li>Job specialization: Different specializations within the DBA field also pay very differently. The best-paying positions are in the newer sub-fields for which there are still not many people, such as Big Data engineers ($140k median) and data scientists ($130k median), as well as senior-level positions such as database manager ($140k median) and data architects/developers ($120k median).</li>
<li>Specialist skills: This means a specialization in specific database software, such as Oracle, SQL Server or MySQL. Being certified in one of these softwares generally adds 7-15% to a base database administrator salary, since they demonstrate an ability to manage the specific system that a company’s database is hosted on. Think of it as the difference between having a general pilot’s license and some flying hours, versus having the training and certification to fly a Boeing 737—an airline with a large number of 737s in its fleet is probably going to be more interested in someone with that kind of specific certification. </li>
<li>Industry sector: Database admins in the tech sector command premium salaries—think Google, Facebook, Amazon, etc. Note that these are all companies that generate and manage huge volumes of data. Other excellent job prospects for DBAs are in the financial and healthcare sectors. These are also industries in which the players typically have many clients, and each can generate a large amount of data.</li>
</ul>
</div>
</div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="title section">
<div data-emptytext="Title">
<h3 class="     title--center    ">
Pathways to a successful database administrator career
</h3>
</div></div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="text parbase section">
<div class="text-component    ">
<p><span style={{fontFamily: 'inherit', lineHeight: '1.4' ,letterSpacing: '-0.015em'}}>There are two main paths to become a database administrator: Focusing on being a DBA from the beginning of an </span><a href="https://www.pluralsight.com/blog/it-ops/it-certification-101" style={{fontFamily: 'inherit', lineHeight: '1.4', letterSpacing: '-0.015em'}}>IT career</a><span style={{fontFamily: 'inherit', lineHeight: '1.4', letterSpacing: '-0.015em'}}>, or (more commonly) starting in a general ICT field, such as helpdesk support or development, and gradually becoming more proficient in database administration.</span><br/>

</p>
<p><span style={{fontFamily: 'inherit', lineHeight: '1.4', letterSpacing: '-0.015em'}}>Either way, being a proficient database administrator will not occur overnight; one first needs to develop certain proficiencies that are also necessary in most ICT careers:</span><br/>

</p>
</div>
</div>
<div class="list section"><div class="list-comp">
<ul>
<li>Excellent troubleshooting skills: When presented with a problem, especially one you have not encountered before, the ability to think through the possible causes and then eliminate or follow them logically to the end is absolutely crucial. A good DBA is one who can see an error, and then quickly determine potential causes and construct possible solutions.</li>
<li>Logical thinking, common sense and above-average memory: The natural ability to think methodically using an elimination-based approach, coupled with a good memory, is also important. This includes the ability to recall technical facts about various systems and platforms relevant to your setup, such as how to increase a table’s size in your SQL Server database, how to add a new disk on your Linux server, and how to delete a user in your PostgreSQL database. Likewise, keeping in mind several specific facts about your particular environment (Do you operate in a LAN or WAN? What are the administrator passwords to the databases? How many users do you have? When is your next database audit? Where are your backups stored?) is crucial. </li>
<li>Curiosity and a strong desire to learn: Curiosity and drive will help ensure that you do not stagnate in your database administrator career. The IT field is ever-changing—only the ability and hunger to keep learning new things will keep you from being left behind.</li>
</ul>
</div>
</div>
<div class="text parbase section">
<div class="text-component    ">
<p>The qualities that will turn novices into good DBAs are discussed and explored in various discussions<a href="https://dba.stackexchange.com/questions/53458/i-want-to-become-a-database-administrator-how-can-i-start"> here</a>.</p>
</div>
</div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="title section">
<div data-emptytext="Title">
<h3 class="     title--center    ">
ETA to become a database administrator
</h3>
</div></div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="text parbase section">
<div class="text-component    ">
<p>So, how long will it take you to become a good DBA—someone who can reasonably be left in charge of at least a mid-sized company’s databases? When considering the most common type of database administrator – a production DBA who looks after a company’s databases – there are a number of variables to consider.</p>
<p>First, becoming a database administrator calls for some pre-existing skills, both technical (already being a good systems administrator) and personal (a hunger to learn and troubleshoot). This in turn means that most seasoned production DBAs have first gained experience in other related IT job categories, such as IT support roles. This is an excellent foundation for a future DBA because it ensures that you first learn in detail about the organization’s IT setup, which is almost always required knowledge for a DBA. Other tracks to becoming a DBA are being a developer or a systems administrator, then gradually being tasked with database administration as part of the job.</p>
<p>It is not common, but some organizations do advertise, recruit and train interns and fresh employees with little experience to become database administrators. But it is far more likely that your first experience as a DBA will be after a period of first being in another role, probably general IT support, system administrator or developer. After you have proved yourself, you can then be start to be trusted with the organization’s data.</p>
<p>As such, in order to determine how long it will take to become a database administrator, you need to look at the math. The assumptions below are very general database administrator education requirements for a rookie DBA, not for someone already working as a database administrator looking to switch database administration jobs:</p>
</div>
</div>
<div class="list section"><div class="list-comp">
<ul>
<li>Most organizations require a four-year college degree in an IT field. But many in the ICT field, especially development and programming companies, are starting to seriously question the value of a very general four-year degree, and are leaving it out of their database administrator requirements.</li>
<li>Next, one needs to pursue database administrator training and certifications. Becoming a good DBA also requires technical training and database administrator certifications. These can take anywhere from a month to about six months.</li>
<li>One will likely need to work in another role within IT for some time before being trusted enough to handle the sensitive DBA role, meaning that another year to three years is likely. A very lucky few get to become DBAs straight into the job with no experience at all, but this is rare.</li>
<li>To become somewhat proficient as a DBA, it will call for at least two to four years working full-time in a busy environment. To master more advanced concepts, such as performance tuning and database replication and mirroring, it may take several years more.</li>
</ul>
</div>
</div>
<div class="text parbase section">
<div class="text-component    ">
<p>Considered all together, becoming an entry-level database administrator means anywhere from two to seven years. But once you land your first database administrator job, it will take at least another three years before you’ll be able to develop any sort of proficiency as a DBA. And to become an expert? Well, you will find that strangely, most highly-knowledgeable DBAs shy away from the ‘expert’ moniker. Why? Because they appreciate how much they still don’t know and still learn every day. And because even in a very specific sub-specialization of database administrator, say SQL Server on Windows, there is always someone who knows even more.</p>
<p>This highlights another fact about the database administrator field: you will always be learning something new. The software and platforms are always changing. New non-relational databases, along with new versions of existing databases, create an ever-shifting landscape that can be difficult to navigate without constant education. At the same time, the database administration field encompasses so many other related areas of expertise within IT (such as systems administration, <a href="https://www.pluralsight.com/courses/sql-server-virtualization-planning-practice">virtualization</a>, networking, cloud computing, etc.), that database administrators find themselves constantly acquiring new nuggets of information throughout their careers.</p>
</div>
</div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="title section">
<div data-emptytext="Title">
<h3 class="     title--center    ">
Database administrator training and certifications
</h3>
</div></div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="text parbase section">
<div class="text-component    ">
<p>For most employers and hiring managers looking to hire someone with experience, a minimum is a four-year bachelor’s or two-year associate’s degree in any ICT field. However as we saw before, some are starting to leave out this requirement altogether and opt for technical training through online learning and other sources. Still, a college degree in ICT, <a>engineering, or statistics </a><a name="_msoanchor_1"></a>[GE1]&nbsp;will give you an advantage over other applicants.</p>
<p>Next, it is a good idea to get certified in one or more commercial database systems. Your college degree may have taught you the basics of database administration, and you may have even learned some <a href="https://www.pluralsight.com/courses/sql-server-understanding-using-dbcc-commands">SQL</a>, but this is only an introduction. Most companies will focus on hiring people with certification and DBA training in the specific database software they use. Some of the big players and their database administrator certifications are:<a name="_msocom_1"></a></p>
<p></p><p></p><p></p><p>Might consider adding in Statistics. This tends to be more for the data science jobs, but I’ve seen this start to stretch into the admin roles as well in SMBs as they’re looking for the admin to do more than just admin.</p>
<p></p>
<p></p>
<p></p>
</div>
</div>
<div class="list section"><div class="list-comp">
<ul>
<li>Oracle: Oracle DB Certified Associate, Oracle DB Certified Professional</li>
<li>Microsoft SQL Server: MCSE (Data platform and Business Intelligence) and the older MCDBA</li>
<li>IBM: IBM Analytics Certification</li>
<li>Oracle: MySQL Database Developer, MySQL Database Administrator</li>
<li>MongoDB: Certified DBA, Certified Developer</li>
<li>Cassandra: Certified Cassandra Administrator, Certified Cassandra Architect, Certified Cassandra Developer</li>
</ul>
</div>
</div>
<div class="text parbase section">
<div class="text-component    ">
<p>If you already have a job and are looking to move into the database administration field, it is a good idea to find out if your organization is already using one of the widely-available database platforms listed above. If they are using some little-known, obscure platform instead, it doesn’t hurt to get certified in a lesser known platform so you can kick off your DBA career. But, you should still look at supplementing your entry-level database administrator resume and increasing your marketability later on with something more common. If you don’t already have a job and are looking to start, then first make sure you research the available database platforms. One good place to start is to take a look at how many database administrator jobs are advertised and list specific certifications, such as<a href="http://www.tomsitpro.com/articles/database-certifications,2-664.html"> here</a>. This will give you a good idea of how many openings there are, and therefore how much comparative demand there is for a certain database administrator certification.</p>
<p>Many of these database administrator courses and trainings are available online. Simply pay a fee, download the course and train yourself. You can also use <a href="https://www.pluralsight.com/browse/it-ops/database-administration">Pluralsight’s database administration</a> training to get ahead. Some advanced courses require previous certification. For example, you’ll need to first acquire the Oracle Certified Associate certification before undertaking the Oracle Certified Professional course.</p>
</div>
</div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="title section">
<div data-emptytext="Title">
<h3 class="     title--center    ">
Typical DBA projects
</h3>
</div></div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="text parbase section">
<div class="text-component    ">
<p>So what does a database administrator do exactly? We previously listed a DBAs duties, but here they are in summary:</p>
</div>
</div>
<div class="list section"><div class="list-comp">
<ul>
<li>Database installation and configuration</li>
<li>Data security</li>
<li>User creation and maintenance</li>
<li>Database backups and recovery</li>
<li>Database performance tuning and optimization</li>
<li>Data transformation and loading</li>
<li>Reporting and querying</li>
</ul>
</div>
</div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="title section">
<div data-emptytext="Title">
<h3 class="     title--center    ">
Reporting and querying
</h3>
</div></div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="text parbase section">
<div class="text-component    ">
<p>The last item in the list above, producing reports and querying the database, is especially important and warrants a bit more discussion. The most important function of a database, besides being a centrally organized repository of the organization’s data, is to turn raw data into actionable intelligence. As such, a database administrator can use his or her query skills to answer some important questions needed by management, such as who were the top clients by sales last quarter, and how many clients signed up and then left within a single calendar year, for each of the last five years?</p>
<p>To produce these reports, a database administrator uses a query language. By far the most widely used, and a prerequisite for any database administrator worth is <a href="https://www.pluralsight.com/courses/sql-server-understanding-using-dbcc-commands">SQL</a>, the Structured Query Language. SQL is used to run queries on relational databases—databases that store their data in relations, the technical term for database tables.<span style={{fontFamily: 'inherit', lineHeight: '1.4', letterSpacing: '-0.015em'}}>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span></p>
<p>There is a newer type of database called non-relational databases that use a class of query languages called <a href="https://www.pluralsight.com/courses/nosql-big-pic">NoSQL</a>. These are mostly used for very large datasets, such as those on large websites where relational databases would not be ideal. Some examples of these databases are Cassandra, Hadoop and MongoDB. But by and large, SQL is still a must-have skill for any serious DBA.&nbsp; &nbsp;&nbsp;<br/>

</p>
</div>
</div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="title section">
<div data-emptytext="Title">
<h3 class="     title--center    ">
SQL tuning
</h3>
</div></div>
<div class="column-control section">
<div>
<div class="container column-control-container ">
<div class="row large     padding-top-eighty  ">
<div class="large-12 columns ">
</div>
</div>
</div>
</div>
</div>
<div class="text parbase section">
<div class="text-component    ">
<p>The last item in the list above, producing reports and querying the database, is especially important and warrants a bit more discussion. The most important function of a database, besides being a centrally organized repository of the organization’s data, is to turn raw data into actionable intelligence. As such, a database administrator can use his or her query skills to answer some important questions needed by management, such as who were the top clients by sales last quarter, and how many clients signed up and then left within a single calendar year, for each of the last five years?</p>
<p>To produce these reports, a database administrator uses a query language. By far the most widely used, and a prerequisite for any database administrator worth is <a href="https://www.pluralsight.com/courses/sql-server-understanding-using-dbcc-commands">SQL</a>, the Structured Query Language. SQL is used to run queries on relational databases—databases that store their data in relations, the technical term for database tables.<span style={{fontFamily: 'inherit', lineHeight: '1.4', letterSpacing: '-0.015em'}}>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span></p>
<p>There is a newer type of database called non-relational databases that use a class of query languages called <a href="https://www.pluralsight.com/courses/nosql-big-pic">NoSQL</a>. These are mostly used for very large datasets, such as those on large websites where relational databases would not be ideal. Some examples of these databases are Cassandra, Hadoop and MongoDB. But by and large, SQL is still a must-have skill for any serious DBA.&nbsp; &nbsp;&nbsp;<br/>

</p>
</div>
</div>
<div class="text parbase section">
<div class="text-component    ">
<p>A related and important skill for a database administrator is SQL tuning, or query optimization. This means creating SQL statements that place the minimum possible load on the database in terms of CPU, memory management and disk access.</p>
<p>In your work as a database administrator, you will likely experience SQL queries or statements that take unacceptably long to run and return results. It is your duty to use your knowledge to delve into such queries to locate the root cause of these problems. Because of this, it is a skill that you should try and gain proficiency in sooner, rather than later. <u>G</u>et an intro to SQL query tuning <a href="http://beginner-sql-tutorial.com/sql-query-tuning.htm">here</a>.</p>
<p>With the right aptitude, the proper training and a clear focus on your goals, you can develop the skills necessary for a career in database administration—but it may take some time. However, the need for database administrators is one that cannot be overemphasized, and that need is steadily growing. After all, data is the currency of the future, and if you can establish yourself as an administrator of that data, then you’ll always be in demand.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
    )
}

export default Dba
